import { Injectable } from '@angular/core';

@Injectable()
export class InstitutionService {
  private _institutionId: number;

  constructor() { }

  set institutionId(institutionId: number) {
    this._institutionId = institutionId;
  }

  get institutionId() {
    return this._institutionId;
  }
}
